import React from 'react'
import { Button, Checkbox, FormControlLabel, TableCell, TableRow, Tooltip, Typography } from "@mui/material";
import axios from 'axios'
import imgTool from '../../utils/imgTool';
import ProductsLogsDialog from './ProductsLogsDialog';
import Filter2Icon from '@mui/icons-material/Filter2';
import { PlayArrow } from '@mui/icons-material';
const minimal_base64_img = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

const TableListRow = (props: any) => {
  const [productsLogsDialogOpen, setProductsLogsDialogOpen] = React.useState(false)
  const productsLogsClickedId = React.useRef('')


  const processContent = (key: string, data: { [x: string]: string | number | boolean }) => {
    return key === 'createdAt' || key === 'updatedAt' || key === 'launch_date' || key === 'arrive_date' || key === 'cut_off_date'
      ? key === 'launch_date' || key === 'arrive_date' || key === 'cut_off_date'
        ? data[key]
          ? new Date(data[key].toString()).toLocaleDateString()
          : '<未设定日期>'
        : new Date(data[key].toString()).toLocaleString()
      : (key === 'mainImage' || key === 'images' || key === 'animal_references')
        ? `${data[key] == undefined || data[key] == "" ? "<无>" : ""}`
        : key == "animal_bundle" ? (data[key] == true ? '捆绑销售' : '单独') : (
          `${data[key] !== undefined && data[key] !== '' && data[key] !== 0 && data[key] !== null && data[key].toString().replaceAll(' ', '') !== ''
            ? (key === 'presale_open' ? (data[key] ? "开启预售" : "关闭预售")
              :
              key === 'in_stock' ? (data[key] ? "在售" : "售罄") : data[key]
            ) : '<无>'}`
        )

  }

  const onProductsLogsClick = (_id: string) => (event: any) => {
    setProductsLogsDialogOpen(!productsLogsDialogOpen)
    productsLogsClickedId.current = _id
  }


  return (
    <TableRow
      key={props.item._id}
      hover
      selected={props.checkboxSelected}
    >
      <TableCell
        padding="checkbox"
      >
        <FormControlLabel
          labelPlacement='start'
          label={`${(props.index + 1) + props.pageLimit * (props.currentPage)}.`}
          control={
            <Checkbox
              onClick={(event) => { props.handleSubCheckboxClick(event, props.index) }}
              checked={props.checkboxSelected}
            />
          }
        />
      </TableCell>
      {
        Object.keys(props.schema).map((key: any, index2: number) => {
          return (
            props.schema[key].display !== false && <TableCell
              key={`${props.item}_${index2}`}
              sx={{ px: 1, py: key === 'mainImage' ? 0 : null }}
            >{
                <Tooltip
                  title={key === 'name_zh' || key === 'name_jp' || key === 'warehouse_stock_product_name' ? props.item[key] : ''}
                  placement='right'
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      sx={{ cursor: 'pointer', whiteSpace: 'nowrap', maxWidth: key == "images" ? '6em' : '14em', overflowX: key === 'mainImage' ? 'visiable' : 'hidden', width: 'fit-content', display: 'flex' }}
                      onClick={props.handleEditClick(props.item._id, key, props.item[key], props.index, props.schema[key].editable)}
                      onMouseLeave={() => { document.getElementById('previewHoverImg')!.style.display = 'none' }}
                    >
                      {
                        // key !== 'mainImage' && key !== 'images' &&
                        processContent(key, props.item)
                      }
                      {
                        key === 'mainImage' && props.item[key]
                        && <img
                          id={props.item._id + '_img'}
                          data-src={imgTool.getSmallerImgUrl(props.item[key])}
                          data-base64ed={props.item['base64ed'] ? 0 : props.item['base64ed']}
                          src={props.item['base64ed'] ? minimal_base64_img : imgTool.getSmallerImgUrl(props.item[key], 24)}
                          style={{ width: '2em', height: '2em', objectFit: 'cover', transformOrigin: 'left center' }}
                          onMouseOver={async () => { document.getElementById('previewHoverImg')!.setAttribute('src', await props.handleGetImgWithCache(props.item[key], props.item._id, 0)); document.getElementById('previewHoverImg')!.style.display = 'block' }}
                          onMouseLeave={() => { document.getElementById('previewHoverImg')!.style.display = 'none' }}
                        ></img>
                      }
                      {
                        (key === 'images' || key === 'animal_references') && props.item[key]
                        && props.item[key].map((url: string, url_index: number) => {
                          if (url_index <= 2) {
                            //子图视频
                            if (url.endsWith('.mp4') || url.endsWith(".mov")) {
                              return <video
                                key={url_index}
                                src={url}
                                poster={url + '?x-oss-process=video/snapshot,t_0,f_jpg,ar_auto,w_80,h_80'}
                                preload="none"
                                style={{ width: '2em', height: '2em', objectFit: 'cover', transformOrigin: 'left center' }}
                              ></video>
                            } else {
                              //子图图片
                              return <img
                                key={url_index}
                                src={imgTool.getSmallerImgUrl(url, 24)}
                                style={{ width: '2em', height: '2em', objectFit: 'cover', transformOrigin: 'left center' }}
                                onMouseOver={async () => { document.getElementById('previewHoverImg')!.setAttribute('src', await props.handleGetImgWithCache(url, props.item._id, 0)); document.getElementById('previewHoverImg')!.style.display = 'block' }}
                                onMouseLeave={() => { document.getElementById('previewHoverImg')!.style.display = 'none' }}
                              ></img>
                            }

                          }
                        }
                        )
                      }
                    </Typography>
                    {
                      (key === 'product_code' || key === 'product_code_box') && props.item[key] ? <Button startIcon={props.item.hasRespeatProductCode? <Filter2Icon color='warning'></Filter2Icon>:""} size='small' onClick={async (event) => {
                        event?.preventDefault()
                        await navigator.clipboard.writeText(props.item[key])
                        props.newAlert("复制成功!")
                      }}>复制</Button> : ''
                    }
                  </div>
                </Tooltip>
              }
            </TableCell >
          )
        })
      }
      <TableCell>
        <Typography
          sx={{ whiteSpace: 'nowrap' }}
          onClick={onProductsLogsClick(props.item._id)}
        >日志</Typography>
      </TableCell>
      <ProductsLogsDialog
        open={productsLogsDialogOpen}
        setOpen={setProductsLogsDialogOpen}
        _id={productsLogsClickedId.current}
      ></ProductsLogsDialog>
    </TableRow >
  )
}

export default React.memo(TableListRow, (prevProps, nextProps) => {
  let result = true
  if (prevProps.checkboxSelected != nextProps.checkboxSelected) {
    result = false
  }

  if (prevProps.item !== nextProps.item) {
    result = false
  }
  return result
})